import { getCompetitionSeasonPageUrl } from "../../../../utils/urls"
import { useRouter } from "next/router"
import { LocalizedSeason } from "../../../../types/season"
import style from "./style.module.scss"
import Select from "@components/UI/Select/Select"

export function CompetitionSeasonSelector({
  competitionCalciocomSlug,
  seasonCalciocomSlug,
  seasons,
  page,
}: {
  competitionCalciocomSlug: string
  seasonCalciocomSlug: string
  seasons: LocalizedSeason[]
  page: string
}) {
  const router = useRouter()

  const redirect = (e: string | number) => {
    const url = e
    router.push(url as string)
  }

  return (
    <div className={style.moduleSelect}>
      <Select
        onChange={redirect}
        value={getCompetitionSeasonPageUrl(competitionCalciocomSlug, seasonCalciocomSlug, page) as string}
        options={seasons.map((season) => {
          return {
            value: getCompetitionSeasonPageUrl(competitionCalciocomSlug, season.calciocomSlug!, page),
            label: season.name,
          }
        })}
      />
      {/* <select
        className={style.seasonNavigation}
        onChange={redirect}
        value={getCompetitionSeasonPageUrl(competitionCalciocomSlug, seasonCalciocomSlug, page)}
      >
        {seasons.map((season) => {
          return (
            <option
              key={season.id}
              value={getCompetitionSeasonPageUrl(competitionCalciocomSlug, season.calciocomSlug!, page)}
            >
              {season.name}
            </option>
          )
        })}
      </select> */}
    </div>
  )
}
